import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  editFilters: {
    id: 'gradebook.GradesView.editFilterLabel',
    defaultMessage: 'Edit Filters',
    description: 'A labeled button in the Grades tab that opens/closes the Filters tab, allowing the grades to be filtered',
  },
});

export default messages;
